<template>
  <v-row
    v-if="
      room &&
      featuresField &&
      room[featuresField] &&
      Object.keys(room[featuresField]).length > 0
    "
    class="object-features"
    no-gutters
  >
    <v-col
      cols="12"
      class="pt-3 pb-1"
    >
      <h3>{{ title }} {{ room.number }}</h3>
    </v-col>
    <template v-for="featureId in filteredAndSortedFeatureIds">
      <v-col
        :key="featureId + '_quantity'"
        cols="1"
        class="text-right pr-1"
      >
        <template
          v-if="
            room[featuresField][featureId].quantity &&
            !showQtyIcons.includes(featuresList[featureId].icon)
          "
        >
          {{ room[featuresField][featureId].quantity }} x
        </template>
      </v-col>
      <v-col
        cols="11"
        :key="featureId + '_name'"
      >
        <template
          v-if="
            showQtyIcons.includes(featuresList[featureId].icon) &&
            room[featuresField][featureId].quantity
          "
        >
          <v-icon
            v-for="(icon_i, i2) in Array(
              parseInt(room[featuresField][featureId].quantity)
            )"
            :key="icon_i"
            :class="
              i2 < parseInt(room[featuresField][featureId].quantity) - 1 ||
              parseInt(room[featuresField][featureId].quantity) > 1
                ? 'mr-2'
                : ''
            "
          >
            {{ featuresList[featureId].icon }}
          </v-icon>
          {{
            parseInt(room[featuresField][featureId].quantity) > 1
              ? room[featuresField][featureId].quantity
              : ''
          }}
        </template>
        <v-icon v-else>
          {{ featuresList[featureId].icon }}
        </v-icon>
        {{ featureName(featureId) }}
      </v-col>
    </template>
  </v-row>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectRoomFeatures',

  data() {
    return {
      showQtyIcons: ['mdi-bed-king', 'mdi-bed-queen', 'fa-couch', 'mdi-sofa'],
    }
  },

  props: {
    featuresField: {
      type: String,
      default: null,
    },
    room: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),

    filteredAndSortedFeatureIds() {
      return Object.keys(this.room[this.featuresField])
        .filter((featureId) => {
          return (
            this.featuresList[featureId] &&
            this.room[this.featuresField][featureId].checked === true
          )
        })
        .sort((a, b) => {
          return this.featuresList[a]?.sortOrder >=
            this.featuresList[b]?.sortOrder
            ? 1
            : -1
        })
    },
  },

  methods: {
    ...sharedMethods,

    featureName(featureId) {
      let title = this.capitalize(
        this.featuresList[featureId]['name_' + this.lang]
      )
      if (
        this.room[this.featuresField][featureId].quantity &&
        parseInt(this.room[this.featuresField][featureId].quantity) > 1
      ) {
        title =
          this.capitalize(
            this.featuresList[featureId]['namePlural_' + this.lang]
          ) || title
      }
      return (
        title +
        (this.room[this.featuresField][featureId].distance
          ? ': ' + this.room[this.featuresField][featureId].distance
          : '')
      )
    },
  },
}
</script>
